const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  quantityUpdateChecked: 'quantity-update-checked',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  quickAddModalShow: 'quick-add-modal-show',
};

const BREAKPOINTS = {
  tablet: 750,
  desktop: 990,
  desktop_medium: 1200,
  desktop_large: 1440,
};